import api from './api';
import { handleError } from './handle-error';
import { toastSuccess } from './toast';

// Inativacao terminal de unit. Operacao nao reversivel pelo backend.
// Doc: docs/FEAT-007_inativacao-terminal-units.md
export const inactivateUnit = async (unit_id) => {
  const result = new Promise((resolve) => {
    api
      .post(`units/${unit_id}/inactivate`)
      .then((response) => {
        toastSuccess('Unidade inativada permanentemente.');
        resolve(response.data);
      })
      .catch(async (error) => {
        const response = await handleError(error);
        resolve(response);
      });
  });
  return result;
};

export const addSellerToUnit = async (unit_id, seller_id) => {
  const result = new Promise((resolve) => {
    api
      .post(`units/${unit_id}/sellers/${seller_id}`)
      .then((response) => {
        toastSuccess('Novo vendedor incluido com sucesso!');
        resolve(response.data);
      })
      .catch(async (error) => {
        const response = await handleError(error);
        resolve(response);
      });
  });
  return result;
};

export const removeSellerFromUnit = async (unit_id, seller_id) => {
  const result = new Promise((resolve) => {
    api
      .delete(`units/${unit_id}/sellers/${seller_id}`)
      .then((response) => {
        toastSuccess('Vendedor removido com sucesso!');
        resolve(response.data);
      })
      .catch(async (error) => {
        const response = await handleError(error);
        resolve(response);
      });
  });
  return result;
};
